import React, { useEffect, useRef, useState } from "react";
import "../../styles/aboutus.css";
import { aboutUs } from "../../data/aboutUs";
import { works } from "../../data/works";
import whychooseus1 from '../../assets/images/aboutus/whychooseus1.jpg';
import whychooseus2 from '../../assets/images/aboutus/whychooseus2.jpg';

// Two dummy placeholder photos for the collage until real HKI team/client
// photography is supplied — reusing existing work posters, same approach
// already used for the values grid above.
const COLLAGE_IMAGES = [works[0], works[5]].map((w) => w.media.poster);

const isReducedMotion = () =>
  typeof window !== "undefined" &&
  window.matchMedia &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

const AboutUsWhyChooseUs = () => {
  const { title, items } = aboutUs.whyChooseUs;
  const sectionRef = useRef(null);
  const [revealed, setRevealed] = useState(false);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return undefined;

    if (isReducedMotion()) {
      setRevealed(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          setRevealed(true);
          observer.disconnect();
        });
      },
      { threshold: 0.08 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section className={`aboutus_why ${revealed ? "is-revealed" : ""}`} ref={sectionRef}>
      <span className="aboutus_why_glow" aria-hidden="true" />

      <div className="aboutus_why_inner">
        <div className="aboutus_why_collage">
          <span className="aboutus_why_dot aboutus_why_dot--1" aria-hidden="true" />
          <span className="aboutus_why_dot aboutus_why_dot--2" aria-hidden="true" />

          <div className="aboutus_why_collage_item aboutus_why_collage_item--big1">
            <img loading="lazy" decoding="async" src={whychooseus1} alt="" aria-hidden="true" />
          </div>
          <div className="aboutus_why_collage_item aboutus_why_collage_item--big2">
            <img loading="lazy" decoding="async" src={whychooseus2} alt="" aria-hidden="true" />
          </div>
        </div>

        <div className="aboutus_why_content">
          <h2 className="aboutus_why_title">{title}</h2>

          <ul className="aboutus_why_list">
            {items.map((item, i) => (
              <li
                className="aboutus_why_item"
                style={{ transitionDelay: `${0.1 + i * 0.06}s` }}
                key={item}
              >
                <span className="aboutus_why_item_text">{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default AboutUsWhyChooseUs;
